// 租金账单
const rentFinanceJurisdiction = [
  { id: "013002001", label: "修改账单", children: [] },
  { id: "013002002", label: "批量修改发票状态", children: [] },
  { id: "013002003", label: "导出", children: [] },
  { id: "013002004", label: "修改含税标识", children: [] },
  { id: "013002005", label: "批量修改含税标识", children: [] },
  { id: "013002006", label: "账单分账", children: [] },
  { id: "013002007", label: "生成通知单", children: [] },
  { id: "013002008", label: "批量生成通知单", children: [] }
];

// 物业账单
const propertyFinanceJurisdiction = [
  { id: "013002010", label: "修改账单", children: [] },
  { id: "013002011", label: "生成通知单", children: [] },
  { id: "013002012", label: "批量生成通知单", children: [] },
  { id: "013002013", label: "导出", children: [] },
  { id: "013002014", label: "批量修改发票状态", children: [] }
];

// 保证金及其他账单
const depositFinanceJurisdiction = [
  { id: "013002016", label: "修改", children: [] },
  { id: "013002017", label: "导出", children: [] }
];

// 其他合约账单管理
const otherRentFinanceJurisdiction = [
  { id: "013003001", label: "修改", children: [] },
  { id: "013003002", label: "批量修改发票状态", children: [] },
  { id: "013003003", label: "更新含税标志", children: [] },
  { id: "013003004", label: "批量更新含税标志", children: [] },
  { id: "013003005", label: "批量修改缴费状态", children: [] },
  { id: "013003006", label: "导出", children: [] },
  { id: "013003007", label: "批量生成通知单", children: [] }
];

// 电费充值账单
const electricityChargeJurisdiction = [
  { id: "013004001", label: "修改", children: [] },
  { id: "013004002", label: "生成通知单", children: [] },
  { id: "013004003", label: "批量生成通知单", children: [] }
];

// 电费月度账单
const electricityMonthlyJurisdiction = [
  { id: "013004005", label: "修改", children: [] },
  { id: "013004006", label: "导入公摊", children: [] },
  { id: "013004007", label: "生成账单", children: [] },
  { id: "013004008", label: "生成通知单", children: [] },
  { id: "013004009", label: "批量生成通知单", children: [] }
];

// 电费余额管理
const electricityFinanceRentRecordJurisdiction = [
  { id: "013005001", label: "手动充值", children: [] },
  { id: "013005002", label: "删除", children: [] },
  { id: "013005003", label: "结算", children: [] },
  { id: "013005004", label: "导出", children: [] }
];

// 电费充值记录
const electricityFinancePayRecordJurisdiction = [
  { id: "013006001", label: "导出", children: [] }
];

// 水费账单管理
const waterFinanceBillJurisdiction = [
  { id: "013008001", label: "修改", children: [] },
  { id: "013008002", label: "生成通知单", children: [] },
  { id: "013008003", label: "批量生成通知单", children: [] },
  { id: "013008004", label: "修改开票状态", children: [] },
  { id: "013008005", label: "导入公摊", children: [] },
  { id: "013008006", label: "生成账单", children: [] },
];

// 水费余额管理
const waterFinanceRentRecordJurisdiction = [
  { id: "013009001", label: "手动充值", children: [] },
  { id: "013009002", label: "删除", children: [] },
  { id: "013009003", label: "结算", children: [] },
  { id: "013009004", label: "导出", children: [] }
];

// 水费充值记录
const waterFinancePayRecordJurisdiction = [
  { id: "013010001", label: "导出", children: [] }
];

// 蒸汽账单管理
const steamFinanceBillJurisdiction = [
  { id: "013020001", label: "修改", children: [] },
  { id: "013020002", label: "生成通知单", children: [] },
  { id: "013020003", label: "批量生成通知单", children: [] },
  { id: "013020004", label: "修改开票状态", children: [] },
  { id: "013020005", label: "导入公摊", children: [] },
  { id: "013020006", label: "生成账单", children: [] },
];

// 蒸汽余额管理
const steamFinanceRentRecordJurisdiction = [
  { id: "013021001", label: "手动充值", children: [] },
  { id: "013021002", label: "删除", children: [] },
  { id: "013021003", label: "结算", children: [] },
  { id: "013021004", label: "导出", children: [] }
];

// 蒸汽充值记录
const steamFinancePayRecordJurisdiction = [
  { id: "013022001", label: "导出", children: [] }
];

// 燃气账单管理
const gasFinanceBillJurisdiction = [
  { id: "013024001", label: "修改", children: [] },
  { id: "013024002", label: "生成通知单", children: [] },
  { id: "013024003", label: "批量生成通知单", children: [] },
  { id: "013024004", label: "修改开票状态", children: [] },
  { id: "013024005", label: "导入公摊", children: [] },
  { id: "013024006", label: "生成账单", children: [] },
];

// 燃气余额管理
const gasFinanceRentRecordJurisdiction = [
  { id: "013025001", label: "手动充值", children: [] },
  { id: "013025002", label: "删除", children: [] },
  { id: "013025003", label: "结算", children: [] },
  { id: "013025004", label: "导出", children: [] }
];

// 燃气充值记录
const gasFinancePayRecordJurisdiction = [
  { id: "013026001", label: "导出", children: [] }
];

// 停车包月账单
const parkingFinanceMonthlyPaymentJurisdiction = [
  { id: "013012001", label: "修改", children: [] },
  { id: "013012002", label: "导出", children: [] }
];

// 停车临停账单
const parkingFinanceTemporaryStopJurisdiction = [
  { id: "013013001", label: "导出", children: [] }
];

// 预约账单
const placeBookingFinancePayRecordJurisdiction = [
  { id: "013014001", label: "修改", children: [] },
  { id: "013014002", label: "导出", children: [] }
];

// 报修账单
const repairFinancePayRecordJurisdiction = [
  { id: "013015001", label: "修改", children: [] },
  { id: "013015002", label: "导出", children: [] }
];

// 其他费用账单
const otherBillJurisdiction = [
  { id: "013016001", label: "修改", children: [] },
  { id: "013016002", label: "导出", children: [] }
];

// 收款管理
const contractPayRecordJurisdiction = [
  { id: "013017001", label: "添加", children: [] },
  { id: "013017002", label: "关联账单", children: [] },
  { id: "013017003", label: "导出", children: [] },
  { id: "013017004", label: "导入", children: [] }
];

// 退款管理
const financeRefundJurisdiction = [
  { id: "013018001", label: "添加", children: [] },
  { id: "013018002", label: "确认退款", children: [] },
  { id: "013018003", label: "导出", children: [] }
];

// 停车临停账单
const tenantListJurisdiction = [
  { id: "013029001", label: "导出", children: [] }
];

// 财务
const financeServiceJurisdictionChildren = [
  {
    id: "013001000",
    label: "概览",
    routerName: "finance-over-view",
    children: []
  },
  {
    id: "013002000",
    label: "租金账单",
    routerName: "rent-finance",
    children: rentFinanceJurisdiction
  },
  {
    id: "013002009",
    label: "物业账单",
    routerName: "property-finance",
    children: propertyFinanceJurisdiction
  },
  {
    id: "013002015",
    label: "保证金及其他账单",
    routerName: "deposit-finance",
    children: depositFinanceJurisdiction
  },
  {
    id: "013003000",
    label: "其他合约账单管理",
    routerName: "other-rent-finance",
    children: otherRentFinanceJurisdiction
  },
  {
    id: "013004000",
    label: "电费充值账单",
    routerName: "electronic-finance-bill",
    children: electricityChargeJurisdiction
  },
  {
    id: "013004004",
    label: "电费月度账单",
    routerName: "electronic-finance-bill",
    children: electricityMonthlyJurisdiction
  },
  {
    id: "013005000",
    label: "电费余额管理",
    routerName: "electronic-finance-rent-record",
    children: electricityFinanceRentRecordJurisdiction
  },
  {
    id: "013006000",
    label: "电费充值记录",
    routerName: "electronic-finance-pay-record",
    children: electricityFinancePayRecordJurisdiction
  },
  {
    id: "013007000",
    label: "电费结算记录",
    routerName: "electronic-finance-settlement-record",
    children: []
  },
  {
    id: "013008000",
    label: "水费账单管理",
    routerName: "water-finance-bill",
    children: waterFinanceBillJurisdiction
  },
  {
    id: "013009000",
    label: "水费余额管理",
    routerName: "water-finance-rent-record",
    children: waterFinanceRentRecordJurisdiction
  },
  {
    id: "013010000",
    label: "水费充值记录",
    routerName: "water-finance-pay-record",
    children: waterFinancePayRecordJurisdiction
  },
  {
    id: "013011000",
    label: "水费结算记录",
    routerName: "water-finance-settlement-record",
    children: []
  },
  {
    id: "013020000",
    label: "蒸汽账单管理",
    routerName: "steam-finance-bill",
    children: steamFinanceBillJurisdiction
  },
  {
    id: "013021000",
    label: "蒸汽余额管理",
    routerName: "steam-finance-rent-record",
    children: steamFinanceRentRecordJurisdiction
  },
  {
    id: "013022000",
    label: "蒸汽充值记录",
    routerName: "steam-finance-pay-record",
    children: steamFinancePayRecordJurisdiction
  },
  {
    id: "013023000",
    label: "蒸汽结算记录",
    routerName: "steam-finance-settlement-record",
    children: []
  },
  {
    id: "013024000",
    label: "燃气账单管理",
    routerName: "gas-finance-bill",
    children: gasFinanceBillJurisdiction
  },
  {
    id: "013025000",
    label: "燃气余额管理",
    routerName: "gas-finance-rent-record",
    children: gasFinanceRentRecordJurisdiction
  },
  {
    id: "013026000",
    label: "燃气充值记录",
    routerName: "gas-finance-pay-record",
    children: gasFinancePayRecordJurisdiction
  },
  {
    id: "013027000",
    label: "燃气结算记录",
    routerName: "gas-finance-settlement-record",
    children: []
  },
  {
    id: "013012000",
    label: "停车包月账单",
    routerName: "parking-finance-monthly-payment",
    children: parkingFinanceMonthlyPaymentJurisdiction
  },
  {
    id: "013013000",
    label: "停车临停账单",
    routerName: "parking-finance-temporary-stop",
    children: parkingFinanceTemporaryStopJurisdiction
  },
  {
    id: "013014000",
    label: "预约账单",
    routerName: "place-booking-finance-pay-record",
    children: placeBookingFinancePayRecordJurisdiction
  },
  {
    id: "013015000",
    label: "报修账单",
    routerName: "repair-finance-pay-record",
    children: repairFinancePayRecordJurisdiction
  },
  {
    id: "013016000",
    label: "其他费用账单",
    routerName: "other-bill",
    children: otherBillJurisdiction
  },
  {
    id: "013017000",
    label: "收款管理",
    routerName: "contract-pay-record",
    children: contractPayRecordJurisdiction
  },
  {
    id: "013018000",
    label: "退款管理",
    routerName: "finance-refund",
    children: financeRefundJurisdiction
  },
  {
    id: "013028000",
    label: "退租账单管理",
    routerName: "refund-bill-management",
    children: []
  },
  {
    id: "013029000",
    label: "报表中心:租户账单",
    routerName: "tenant-list",
    children: tenantListJurisdiction
  },
  {
    id: "013019000",
    label: "操作日志",
    routerName: "finance-log",
    children: []
  }
];

const financeServiceJurisdiction = {
  id: "013",
  label: "智慧财务",
  children: financeServiceJurisdictionChildren
};

export { financeServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/financeServiceJurisdiction.js